module.exports = __webpack_public_path__ + "media/images/home/crm-1b7ff738c9803cd592d04180a16495c0.svg";